export default "__VITE_PUBLIC_ASSET__6bc70b8d__"